// extracted by mini-css-extract-plugin
export default {"image":"PX-z","loaded":"QX-z"};